import PageHeading from "Layout/AppMain/PageHeading";
import React, { Fragment, useEffect, useRef, useState } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Card, CardBody, Col, Row, CardHeader, Table, Label, FormGroup, Input, Button, NavLink, Nav, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from "reactstrap";
import ReactTableGeneric from "Components/ReactTableGeneric";
import { ReactComponent as PdfIcon } from "../../../../assets/utils/images/svgs/PDF.svg";
import { BsCheckCircle } from "react-icons/bs";
import { BsQuestionCircle } from "react-icons/bs";
import { ReactComponent as CrossIcon } from "../../../../assets/utils/images/svgs/Cross.svg";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { ErrorMessage } from "formik";
import TextLimit from "Api/TextLimit";
import { useBesturen, useDownloadProtocol, useFuncties, useSettingsDetails, useUpdateGroup, useUpdateSettings } from "Api/Vervanger/Setting";

const Default = () => {

    const [functiesList, setFunctiesList] = useState([]);
    const [functiesListChunk, setFunctiesListChunk] = useState([]);
    const [protocolId, setProtocolId] = useState(null);

    const { data: protocolData } = useDownloadProtocol(protocolId);
    const travelDistanceTimeout = useRef(null);
    const { trigger: updateGroupMutation } = useUpdateGroup();
    const { trigger: updateSettingsMutation } = useUpdateSettings();

    useEffect(() => {
        return () => {
            if (travelDistanceTimeout.current) {
                clearTimeout(travelDistanceTimeout.current);
            }
        };
    }, []);

    const { data: besturenResponse } = useBesturen();
    const besturenList =
        besturenResponse?.data || [];


    const chunk = (arr, size) =>
        Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
            arr.slice(i * size, i * size + size)
        );

    const {
        data: functiesResponse,
        mutate: mutateFuncties,
    } = useFuncties();
    useEffect(() => {
        if (functiesResponse?.data) {
            setFunctiesListChunk(
                chunk(functiesResponse.data, 3)
            );
            setFunctiesList(
                functiesResponse.data
            );
        }
    }, [functiesResponse]);

    const { data: detailsResponse, mutate: mutateDetails } =
        useSettingsDetails();

    const details =
        detailsResponse?.data || {};



    const iconSwitch = (param) => {
        switch (param) {
            case '+':
                return <span class="float-end"><BsCheckCircle color='#39A825' fontSize={"18px"} /></span>;
            case '?':
                return <span class="float-end"><BsQuestionCircle color='#F2983E' fontSize={"18px"} /></span>;
            case '-':
                return <span class="float-end delete-icon-margin"><CrossIcon color='#FB2E5F' /></span>;
            default:
                return '--';
        }
    }

    useEffect(() => {
        if (protocolData?.file?.download) {
            const link = document.createElement("a");
            link.href = protocolData.file.download;
            link.download = `document.${protocolData.file.extension}`;
            link.click();


            setProtocolId(null);
        }
    }, [protocolData]);

    const downloadFile = (id) => {
        setProtocolId(id);
    };

    const columns = [
        {
            header: 'Bestuur',
            accessorKey: 'vCommunityName',
            cell: value => value.row.original.vCommunityName !== undefined && value.row.original.vCommunityName !== '' &&
                (
                    window.innerWidth > 1250 ?
                        TextLimit.limitStringLargeScreen(value.row.original.vCommunityName)
                        : TextLimit.limitStringSmallScreen(value.row.original.vCommunityName)
                )

        },
        {
            header: 'Regio',
            accessorKey: 'regio'
        },
        {
            header: 'Website',
            accessorKey: 'website'
        },
        {
            header: 'Protocol',
            accessorKey: 'iProtocolId',
            cell: value => value.row.original.iProtocolId !== undefined && value.row.original.iProtocolId !== '' &&
                <a href="javascript:void(0)" onClick={() => downloadFile(value.row.original.iProtocolId)} className="anchor-action-link">
                    <PdfIcon />
                </a>
        },
    ];


    const changeStatus = (groupId, vValue) => {
        var group = [];
        var newGroup = functiesList;

        group.map((value, index) => {
            if (value.id === groupId) {
                group.splice(index, 1);
            }
        })
        group.push({ iSubGroupId: groupId, vValue: vValue });
        newGroup.map((value) => {
            if (value && value.iSubGroupId == groupId) {
                value.vValue = vValue
            }
        })

        setFunctiesList(newGroup);
        let dataToSend;
        var statusVal = '';
        if (vValue === '+') {
            statusVal = '1';
        } else if (vValue === '-') {
            statusVal = '0';
        } else {
            statusVal = '2';
        }

        dataToSend = {
            groupId: groupId,
            value: statusVal,

        };

        updateGroupMutation({
            data: dataToSend,
        }).then(() => {
            mutateFuncties(); // refetches getFuncties
        })
            .catch((error) => {
                console.error(error);
            });
    }

    const validationSchema = Yup.object().shape({
        iMaxTravelDistance: Yup.number().max(300).min(0),
    });

    const handleSubmit = (values, setSubmitting) => {
        const data = {
            type: 'memo',
            memo: values.memo,
        };

        updateSettingsMutation({ data })
            .then(() => {
                mutateDetails();
            })
            .catch((error) => {
                console.error("Failed to update memo:", error);
            })
            .finally(() => {
                setSubmitting(false);
            });
    };

    const updateSetting = (type, value) => {
        const data = {
            type,
            [type]: value,
        };

        setTimeout(() => {
            updateSettingsMutation({ data })
                .then(() => {
                    mutateDetails();
                })
                .catch((error) => {
                    console.error(`Failed to update ${type}:`, error);
                });
        }, 1000);
    };

    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <>
                    <Formik
                        enableReinitialize
                        initialValues={details}
                        validationSchema={validationSchema}
                        onSubmit={(values, { setSubmitting }) => handleSubmit(values, setSubmitting)}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting
                        }) => (
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md="4" sm="4" lg="4">
                                        <Card className="main-card mb-3">
                                            <CardBody className="p-3 pb-5">
                                                <FormGroup row >
                                                    <Label>
                                                        Maximale reisafstand
                                                    </Label>
                                                    <Col sm={12} >
                                                        <Input
                                                            type="number"
                                                            name="iMaxTravelDistance"
                                                            className="me-2 input-border-styling"
                                                            placeholder="Kilometer"
                                                            value={values.iMaxTravelDistance ?? ''}
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                handleChange(e);

                                                                // Clear previous timeout
                                                                if (travelDistanceTimeout.current) {
                                                                    clearTimeout(travelDistanceTimeout.current);
                                                                }

                                                                // Wait until user stops changing the value
                                                                travelDistanceTimeout.current = setTimeout(() => {
                                                                    updateSetting('iMaxTravelDistance', value);
                                                                }, 500);
                                                            }}
                                                        />
                                                        <ErrorMessage name="iMaxTravelDistance" component="small"
                                                            className="block mt-2 invalid-feedback" />
                                                    </Col>
                                                </FormGroup>
                                                <div className="custom-styling">
                                                    <label for="eGym" className="input-wraper-style col-sm-12 col-form-label pt-0">Gymakte </label>
                                                    <select
                                                        id="eGym"
                                                        name="eGym"
                                                        className="rw-dropdown-list rw-widget rw-widget-input rw-widget-picker rw-widget-container rw-placeholder rw-dropdown-list-input"
                                                        value={values.eGym ?? ''}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                            updateSetting('eGym', e.target.value);
                                                        }}
                                                        onBlur={handleBlur}
                                                    >
                                                        <option value="">Selecteer</option>
                                                        <option value="Ja" selected={details !== undefined && details.eGym !== undefined && details.eGym === 'Ja' ? true : false}>Ja</option>
                                                        <option value="Nee" selected={details !== undefined && details.eGym !== undefined && details.eGym === 'Nee' ? true : false}>Nee</option>
                                                        <option value="i.o." selected={details !== undefined && details.eGym !== undefined && details.eGym === 'i.o.' ? true : false}>In opleiding</option>
                                                    </select>
                                                    <ErrorMessage name="eGym" component="small"
                                                        className="block mt-2 invalid-feedback" />
                                                </div>

                                                <div className="custom-styling">
                                                    <label for="reminderSetting" className="input-wraper-style col-sm-12 col-form-label pt-0">Herinneringsmail ontbrekende gegevens </label>
                                                    <select
                                                        id="reminderSetting"
                                                        name="reminderSetting"
                                                        className="rw-dropdown-list rw-widget rw-widget-input rw-widget-picker rw-widget-container rw-placeholder rw-dropdown-list-input"
                                                        value={values.reminderSetting ?? ''}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                            updateSetting('reminderSetting', e.target.value);
                                                        }}
                                                        onBlur={handleBlur}
                                                    >
                                                        <option value="">Selecteer</option>
                                                        <option value="1" selected={details !== undefined && details.reminderSetting !== undefined && details.reminderSetting == '1' ? true : false}>Ja</option>
                                                        <option value="0" selected={details !== undefined && details.reminderSetting !== undefined && details.reminderSetting == '0' ? true : false}>Nee</option>
                                                    </select>
                                                    <ErrorMessage name="reminderSetting" component="small"
                                                        className="block mt-2 invalid-feedback" />
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>

                                    <Col md="8" sm="8" lg="8">
                                        <Card className="main-card mb-3">
                                            <CardBody className="p-3">
                                                <FormGroup row >
                                                    <Label >
                                                        Profiel
                                                    </Label>
                                                    <Col sm={12} >
                                                        <Input
                                                            type="textarea"
                                                            name="memo"
                                                            className="me-2 textarea-styling"
                                                            value={values.memo ?? ''}
                                                            onChange={handleChange}
                                                        />
                                                        <ErrorMessage name="memo" component="small"
                                                            className="block mt-2 invalid-feedback" />
                                                    </Col>
                                                </FormGroup>
                                                <Button className="d-flex align-items-center btn-color-style mb-2 me-2 float-end" size="sm" outline color="primary" type="submit" disabled={isSubmitting}>
                                                    Opslaan
                                                </Button>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </Form>
                        )}
                    </Formik>
                    <Card className="main-card mb-3">
                        <CardHeader className="head-text-color px-3">
                            <h5 className="menu-header-title text-capitalize">
                                Besturen
                            </h5>
                        </CardHeader>
                        <CardBody className="p-3">
                            <ReactTableGeneric
                                data={besturenList}
                                columns={columns}
                                tableClassName="mb-0 table table-borderless table-bordered table-sm table-hover protocol-col-style"
                                filters={{ search: false, pagination: false, sorting: true }}
                            />
                        </CardBody>
                    </Card>
                    <Card className="main-card mb-3">
                        <CardHeader className="head-text-color px-3">
                            <h5 className="menu-header-title text-capitalize">
                                Functies
                            </h5>
                        </CardHeader>
                        <CardBody className="p-3">
                            <Table hover size="sm" borderless className="mb-0 table table-borderless table-bordered table-sm table-hover">
                                <thead>
                                    <tr>
                                        <th class="col-4">Functie</th>
                                        <th class="col-4">Functie</th>
                                        <th class="col-4">Functie</th>
                                    </tr>
                                </thead>
                                <tbody className="functies-table">
                                    {functiesListChunk.length > 0 && functiesListChunk.map((value, index) => {

                                        return (<tr class="functies-table-style">
                                            {value.map((key, index1) => {
                                                return (<td >{window.innerWidth > 1250 ? TextLimit.limitFunctiesLargeScreen(key.vGroup) : TextLimit.limitFunctiesSmallScreen(key.vGroup)}

                                                    {(key !== undefined && key.vValue !== undefined) &&
                                                        <UncontrolledButtonDropdown className="float-end">
                                                            <DropdownToggle color="link" className="p-0">

                                                                {iconSwitch(key !== undefined && key.vValue !== undefined ? key.vValue : '')}
                                                            </DropdownToggle>
                                                            <DropdownMenu end className="rm-pointers dropdown-menu-lg functies-dropdown-width">

                                                                <Nav vertical className="dropdown-custom-link">
                                                                    <NavLink className="link-gap" href="#" onClick={() => changeStatus(
                                                                        key.iSubGroupId, '+'
                                                                    )}>
                                                                        <span><BsCheckCircle color='#39A825' fontSize={"21px"} />  </span>
                                                                        {/* <span>Beschikbaar voor deze functie</span> */}
                                                                    </NavLink>

                                                                    <NavLink className="link-gap navlink-border" href="#" onClick={() => changeStatus(
                                                                        key.iSubGroupId, '?'
                                                                    )}>
                                                                        <span><BsQuestionCircle color='#F2983E' fontSize={"21px"} />  </span>
                                                                        {/* <span>Geen keuze gemaakt</span> */}
                                                                    </NavLink>

                                                                    <NavLink className="link-gap" href="#" onClick={() => changeStatus(
                                                                        key.iSubGroupId, '-'
                                                                    )}>
                                                                        <span><CrossIcon color='#FB2E5F' /> </span>
                                                                        {/* <span style={{ marginLeft: '-5px' }}> Niet beschikbaar voor deze functie</span> */}
                                                                    </NavLink>
                                                                </Nav>
                                                            </DropdownMenu>
                                                        </UncontrolledButtonDropdown>

                                                    }

                                                </td>)
                                            })}

                                        </tr>)
                                    })}
                                </tbody>
                            </Table>
                            <div className="d-flex align-items-end mt-2">
                                <div><span className="me-1"><BsCheckCircle color='#39A825' fontSize={"18px"} /></span></div>
                                <div className="me-5 calendar-agenda__item ">Beschikbaar voor deze functie</div>
                                <div><span className="me-1"><BsQuestionCircle color='#F2983E' fontSize={"18px"} /></span></div>
                                <div className="me-5 calendar-agenda__item">Geen keuze gemaakt</div>
                                <div><span className="me-1"><CrossIcon color='#FB2E5F' /></span></div>
                                <div className="me-5 calendar-agenda__item">Niet beschikbaar voor deze functie</div>
                            </div>
                        </CardBody>
                    </Card>
                </>
            </TransitionOnLoad>
        </Fragment>
    )
};

export default Default;

